import { CampingStyleProps, PriceProps } from '../interfaces'
import { get, patch, post } from './utils/requests'

const update = async (
  campingStyleId: string,
  data: CampingStyleProps
): Promise<{ camping_style: CampingStyleProps }> =>
  patch(`/api/camping_styles/${campingStyleId}`, data)

const getPricesFor = async (campingStyleId: string): Promise<{ prices: PriceProps[] }> =>
  get(`/api/camping_styles/${campingStyleId}/prices`)

export interface IUpsertPricesData {
  sites_attributes: {
    id: string,
    prices_attributes: Partial<PriceProps>[]
  }[]
}

const upsertPricesFor = async (campingStyleId: string, data: IUpsertPricesData) =>
  post(`/api/camping_styles/${campingStyleId}/prices`, data)

const dateConfigurationsFor = async (campingStyleId: string) =>
  get(`/api/camping_styles/${campingStyleId}/date_configurations`)

const CampingStyles = {
  dateConfigurationsFor,
  getPricesFor,
  update,
  upsertPricesFor,
}

export default CampingStyles
